// extracted by mini-css-extract-plugin
module.exports = {"Bar":"Bar--3N-Ns","Light":"Light--2Polj","Dark":"Dark--3nyDF","Neon":"Neon--aVzGG","LightGray":"LightGray--2dw6Q","DarkGray":"DarkGray--2x2Wl"};